// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"badbfb5d","484":"f459f7bb","654":"b797c516","835":"49f6b72e"}[chunkId] + ".chunk.js";
};